import { useTradingSettings } from '@src/providers/AppConfigProvider';
import { useMemo } from 'react';

export function useCompactMobileCardLayout(expandedHeight: number, compactHeight: number) {
  const { compactMobileCards } = useTradingSettings();
  const cardRendererProps = useMemo(() => ({ compact: compactMobileCards }), [compactMobileCards]);

  return {
    cardHeight: compactMobileCards ? compactHeight : expandedHeight,
    cardRendererProps,
    compact: compactMobileCards,
  };
}
